export default {
    data() {
        return {
            widthLimit: 1024,
        }
    },

    computed: {
        mobileVersion() {
            return this.$root.clientWidth < this.widthLimit;
        }
     },
}
